export default __webpack_public_path__ + "static/media/blogpost2.350c9efe.jpg";